import { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from  'react-redux';
import { MDBBtn, 
        MDBCol, 
        MDBInput, 
        MDBRow, 
        MDBCard, 
        MDBCardBody, 
        MDBCardFooter, 
        MDBCardHeader,
        MDBValidation,
        MDBValidationItem,
        MDBPopover,
        MDBPopoverBody
    } from 'mdb-react-ui-kit';


import AlertComponent from '../components/AlertComponent';
import SpinnerWaitComponent from '../components/SpinnerWaitComponent';
import User from '../apis/User';
import { cloneConfigForFormControl, mainpages, sanitizeUserName } from '../common/common';
import { createEchoClient } from '../common/echo';

import TeamLMSLogo from '../images/teamlms_logo.svg';
import LoginQrCode from '../apis/LoginQrCode';
import TeamQRCodeLoading from '../images/team-qr-loading.gif';







class LoginFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {  isForgotPasswordLinkClicked: false,
                        isForgotUsernameLinkClicked: false,
                        isGotoSignupPageButtonClicked: false,
                        isSpinnerWaitShown: false,
                        form_controls: {
                                        username: { value: '', is_invalid: false, message: '', instruction: ''},
                                        password: { value: '', is_invalid: false, message: '', instruction: ''},
                                        remember: { value: false, is_invalid: false, message: '', instruction: ''}
                                      },
                        qrCode: null,
                        uniqueId: null,
                        submit_success: false,
                        submit_error: false,
                        submit_error_code: '',
                        alert_header: '',
                        alert_messages: []
                     };

        this.echo = null;
        this.forgotPasswordClickHandler = this.forgotPasswordClickHandler.bind(this);
        this.forgotUsernameClickHandler = this.forgotUsernameClickHandler.bind(this);
        this.gotoSignupPageButtonClickHandler = this.gotoSignupPageButtonClickHandler.bind(this);
        this.logInBtnClickHandler = this.logInBtnClickHandler.bind(this);
        this.formItemOnChangeHandler = this.formItemOnChangeHandler.bind(this);
        this.modalCloseHandler = this.modalCloseHandler.bind(this);
        this.resendVerification = this.resendVerification.bind(this);
        this.fetchQrCode = this.fetchQrCode.bind(this);
        this.checkLoginWithQRCodeStatus = this.checkLoginWithQRCodeStatus.bind(this);
        this.popoverOpened = this.popoverOpened.bind(this);
        this.subscribeToEchoChannels = this.subscribeToEchoChannels.bind(this);
        this.intervalQrCodeRefresh = null;
        this.intervalPollingLoginWithQrCode = null;

    }

    componentDidMount() {

        // check if global application store has an authenticated user
        if (this.props.authenticatedUser !== null) {
            return; // yes, global session has an authenticated user
        }


        // precheck whether there is an active session on backend side or not.
        this.getAuthenticatedUser();

                /*

        window.Echo.connector.pusher.connection.bind('connected', () => {
            console.log('[Echo] Connected to WebSocket');
        });
          
        window.Echo.connector.pusher.connection.bind('error', (err) => {
            console.error('[Echo] Connection Error', err);
        });

        window.Echo.channel('test-channel') // public channel
            .listen('.TestEvent', (e) => {
                onsole.log('✅ WebSocket event received in React:', e.message);
            });
*/

    }

    componentWillUnmount() {
        if (this.intervalQrCodeRefresh) {
            clearTimeout(this.intervalQrCodeRefresh);
        }


        if (this.state.uniqueId !== null && this.echo !== null) {
            this.echo.leave(`team_lms_database_qr-login.${this.state.uniqueId}`);
            console.log(`Left channel team_lms_database_qr-login.${this.state.uniqueId}`);
        }

        if (this.echo !== null) {
            // disconnect from webscoket
            this.echo.connector.socket.disconnect();
            this.echo = null;
        }
    }

    async fetchQrCode() {
        try {
            const response = await LoginQrCode.generateQrCode();
            this.setState((prevState) => {
                    if (this.echo === null) {
                        console.log("FATAL ERROR: this.echo is not available, can not set state.uniqueId");
                        return;
                    }

                    if (prevState.uniqueId !== null) {
                        // first unsubscribe from channel the old uniqueId if any
                        this.unsubscribeFromEchoChannels(prevState.uniqueId);
                    }
                    return {uniqueId: response.data.unique_id}
                }, () => {

                    if (this.echo === null) {
                        console.log("FATAL ERROR: this.echo is not available, can not subscribe to channel new state.uniqueId");
                        return;
                    }

                    this.subscribeToEchoChannels(this.state.uniqueId);
            });
            this.setState({qrCode: `data:image/svg+xml;base64, ${response.data.qr_code}`});
    
            // Refresh the QR Code every 5 minutes (same as Laravel expiration time)
            this.intervalQrCodeRefresh = setTimeout(this.fetchQrCode, 5 * 60 * 1000);

          } catch (error) {
            console.error("Error fetching QR code:", error);
          }
    }

    popoverOpened() {

        if (this.echo === null) {
            this.echo = createEchoClient();

            console.log("laravel echo client is created");


            this.echo.connector.socket.on('connect_error', (error) => {
                console.error('WebSocket connect_error:', error);
            });

            this.echo.connector.socket.on('error', (error) => {
                console.error('WebSocket general error:', error);
            });

            this.echo.connector.socket.on('disconnect', (reason) => {
                console.warn('WebSocket disconnected:', reason);
            });

            this.echo.connector.socket.on('connect', () => {
                console.log('Client connected to WebSocket.');
                if (this.state.uniqueId !== null) {
                    // Re-subscribe to your channels here:
                    this.unsubscribeFromEchoChannels(this.state.uniqueId);
                    this.subscribeToEchoChannels(this.state.uniqueId);
                }
            });

        }


        if (this.state.uniqueId === null) {
            this.fetchQrCode();
        }
    }


    unsubscribeFromEchoChannels(uniqueId) {
        if (this.echo === null) {
            console.log("this.echo is null");
            return;
        }
        console.log(`leaving ws channel team_lms_database_qr-login.${uniqueId}`);
//        this.echo.leave(`team_lms_database_qr-login.${uniqueId}`);
        this.echo.connector.socket.emit('unsubscribe', `team_lms_database_qr-login.${uniqueId}`);

        
    }

    subscribeToEchoChannels(uniqueId) {
        if (this.echo === null) {
            console.log("this.echo is null");
            return;
        }

        console.log(`subscribing to ws channel team_lms_database_qr-login.${uniqueId}`);
        this.echo.connector.socket.emit('subscribe', `team_lms_database_qr-login.${uniqueId}`);



        console.log(`listening for QRCodeLoginAccepted events`);

/*        
        this.echo.channel(`team_lms_database_qr-login.${uniqueId}`)
                    .listen('QRCodeLoginAccepted', (e) => {
                        console.log("QR Code login accepted!");              
                        // Now stop any loading spinners, errors, etc.
                        this.checkLoginWithQRCodeStatus();
                    });
*/

        // Prevent duplicate listeners
        this.echo.connector.socket.offAny(); // Remove all previous `onAny` listeners
        
        this.echo.connector.socket.onAny((event, ...args) => {
            if (event === 'QRCodeLoginAccepted') {
                // Now stop any loading spinners, errors, etc.
                this.checkLoginWithQRCodeStatus();
            }
            console.log(`[🔔 Any Event Received] ${event}:`, args);
        });

    }

    async checkLoginWithQRCodeStatus() {
        if (!this.state.uniqueId) return;

        try {
            const response = await LoginQrCode.checkLoginWithQrCode(this.state.uniqueId);
            if (response.data.user !== undefined) {
                // clearInterval(this.intervalPollingLoginWithQrCode);

                this.setState({ alert_header: '' });
                this.setState({ alert_messages: [] });


                // this causes component unmount, don't update state after this call
                this.props.storeAuthenticatedUser(response.data.user); 
            }
        } catch (error) {
            // skip unauthenticated QR Code session this part and let the component to handle it.
            console.error("Checking pending QR Code login status: ", error);
        }
    }

    async getAuthenticatedUser() {
        try {
            let response = await User.getauthenticateduser();
            this.setState({ alert_header: '' });
            this.setState({ alert_messages: [] });
            // this causes component unmount, don't update state after this call
            this.props.storeAuthenticatedUser(response.data.user); 
        } catch (error) {
            // skip unauthenticated session this part and let the component to handle it.
        }
    }

    forgotPasswordClickHandler(e) {
        this.setState({isForgotPasswordLinkClicked: true});
    }

    gotoSignupPageButtonClickHandler(e) {
        this.setState({isGotoSignupPageButtonClicked: true});
    }

    formItemOnChangeHandler(event) {
        let key = event.target.id;
        let value = event.target.value;

        let form_controls_copy = { ...this.state.form_controls }; 
        let form_control_copy = { ...this.state.form_controls[key] }; // it is important to copy contents intead of using reference
        
        if (key === 'remember') {
            value = event.target.checked;
        } else if (key === 'username') {
            value = sanitizeUserName(value);
        }
        
        form_control_copy.value = value;
        form_control_copy.is_invalid = false;
        form_control_copy.message = '';
        form_controls_copy[key] = form_control_copy; // all controls
        this.setState({ form_controls: form_controls_copy }); // reference is changed, now all visible parts will be refreshed
        this.setState({ submit_error: false });
        this.setState({ submit_success: false });
    }


    forgotUsernameClickHandler(event) {
        this.setState({ isForgotUsernameLinkClicked: true });
    }


    logInBtnClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.className += ' was-validated';

        this.startLoginSubmission();
    }

    async startLoginSubmission() {

        this.setState({ submit_success: false });
        this.setState({ submit_error: false });
        this.setState({ submit_error_code: '' });
        this.setState({ alert_header: '' });
        this.setState({ alert_messages: '' });
        this.setState({ isSpinnerWaitShown: true });


        try {
            let request_data = { username: this.state.form_controls.username.value,
                                 password: this.state.form_controls.password.value,
                                 remember: this.state.form_controls.remember.value
                               };
            let response = await User.login(request_data);

            this.setState({ isSpinnerWaitShown: false });
            // this causes component unmount, don't update state after this call
            this.props.storeAllGradesWithUnits([]); // empty it to give it a chance to reload from server if necessary
            this.props.setMainPageCode(mainpages.dashboard.code); // redirect newly logged in users to dashboard
            this.props.storeAuthenticatedUser(response.data.user); 


        } catch (error) {
            this.setState({ isSpinnerWaitShown: false });
            if (error.response !== undefined && error.response.data !== undefined && error.response.data.errors !== undefined)
            {
                let errors = error.response.data.errors;
                let form_controls_copy = { ...this.state.form_controls }; // do not mutate state directly
                form_controls_copy['username'] = cloneConfigForFormControl('username', errors, form_controls_copy);
                form_controls_copy['password'] = cloneConfigForFormControl('password', errors, form_controls_copy);
                this.setState({ form_controls: form_controls_copy });

                if (error.response.data.error_code !== undefined) {
                    this.setState({ submit_error_code: error.response.data.error_code });
                }

                if (errors.error !== undefined) { // handle global algoritmical errors
                    this.setState({ alert_header: error.response.data.message });
                    this.setState({ alert_messages: errors.error });
                    this.setState({ submit_success: false });
                    this.setState({ submit_error: true });
                }
            } else {
                // handle catastrophic errors
                this.setState({ alert_header: 'Unknown Error Occured' });
                this.setState({ alert_messages: error.toString() });
                this.setState({ submit_success: false });
                this.setState({ submit_error: true });
            }
            
        }

        
    }

    modalCloseHandler() {
        this.setState({ submit_error_code: '' });
    }

    async resendVerification() {
        await User.resend_verification();
    }


    render() {



        if (this.props.authenticatedUser !== null) {
            return (<Navigate to='/' />);
        }

        if (this.state.isForgotUsernameLinkClicked) {
            return (<Navigate to='/forgotusername' />);
        }
        
        if (this.state.isForgotPasswordLinkClicked) {
            return (<Navigate to='/forgotpassword' />);
        }

        if (this.state.isGotoSignupPageButtonClicked) {
            return (<Navigate to='/signup' />);
        }
        
        let errorMessageComponent = '';
        if (this.state.submit_error) {
            errorMessageComponent = (<AlertComponent 
                                        type='danger'
                                        alert_header={this.state.alert_header} 
                                        alert_messages={this.state.alert_messages} />
                                    );
        }

        let spinnerWaitComponent = '';
        if (this.state.isSpinnerWaitShown) {
            spinnerWaitComponent = (<SpinnerWaitComponent />);
        }

        return(
            <div className='height-full d-flex align-items-center justify-content-center flex-column bg-light'>
                <div className='col-12 col-sm-8 col-md-7 col-lg-6 col-xl-5 col-xxl-4'>
                    <MDBCard md='12' className='fluid'>
                        <MDBCardHeader>
                            <MDBRow>
                                <MDBCol md="9" className="text-start "><h5>TEAM LMS - Oturum Aç</h5></MDBCol>
                                <MDBCol md="3" className="text-end">
                                    <MDBPopover size='sm' color='secondary' className="m-0 p-0" btnChildren={<i className="fas fa-qrcode"></i>} 
                                            onOpen={this.popoverOpened}>
                                        <MDBPopoverBody>
                                            <MDBRow className=" text-center"><p><b>Oturum Açma QR Kodu</b></p></MDBRow>
                                            <MDBRow>
                                            {this.state.qrCode ? (
                                                <img src={this.state.qrCode} alt='Login QR Code' width='160px' height='160px' />
                                                    ) : (
                                                <img src={TeamQRCodeLoading} alt='Loading QR Code' width='160px' height='160px' />
                                            )}
                                            </MDBRow>
                                            <MDBRow className="p-2 text-center"><p>Oturum açmak için <b>TEAM elt QR Code Reader</b> mobil uygulaması ile tarayın!</p></MDBRow>
                                        </MDBPopoverBody>
                                    </MDBPopover>

                                </MDBCol>
                            </MDBRow>
                        </MDBCardHeader>
                        <MDBCardBody>
                        <MDBValidation noValidate>
                            <MDBRow>
                                <MDBCol className='mb-3 d-flex justify-content-center'>
                                    <img src={TeamLMSLogo} alt='TEAM LMS Logo' width='80px' height='80px'/>
                                    
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className='mb-3 d-flex justify-content-center'>
                                    {errorMessageComponent}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className='mb-3'>
                                    <MDBValidationItem feedback={this.state.form_controls.username.message} invalid>
                                        <MDBInput 
                                            type='text' 
                                            id='username'
                                            autoFocus
                                            autoComplete='off'
                                            label='Kullanıcı adı'
                                            onChange={this.formItemOnChangeHandler}
                                            required
                                            value={this.state.form_controls.username.value}
                                            className={this.state.form_controls.username.is_invalid ? 'is-invalid':''}
                                        />
                                    </MDBValidationItem>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBValidationItem feedback={this.state.form_controls.password.message} invalid>
                                        <MDBInput 
                                            type='password' 
                                            id='password'
                                            label='Şifre'
                                            required
                                            autoComplete='off'
                                            onChange={this.formItemOnChangeHandler}
                                            className={this.state.form_controls.password.is_invalid ? 'is-invalid':''}
                                        />
                                    </MDBValidationItem>
                                </MDBCol>
                            </MDBRow>
                        </MDBValidation>
                        </MDBCardBody>
                        <MDBCardFooter>
                            <MDBBtn type='submit' color='primary' className='me-3' onClick={this.logInBtnClickHandler}>OTURUM AÇ</MDBBtn>
                            <MDBBtn color='secondary' onClick={this.gotoSignupPageButtonClickHandler}>HESAP OLUŞTUR</MDBBtn>
                        </MDBCardFooter>
                        {spinnerWaitComponent}
                    </MDBCard>
                    <div className='d-flex justify-content-center mt-3'>
                        <MDBBtn color='link' onClick={this.forgotPasswordClickHandler}>ŞİFREMİ UNUTTUM</MDBBtn>
                        <MDBBtn color='link' onClick={this.forgotUsernameClickHandler}>KULLANICI ADIMI UNUTTUM</MDBBtn>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        authenticatedUser: state.authenticatedUser
    }
};

const mapDispatchToProps = dispatch => {
    return {
        storeAuthenticatedUser: (authenticatedUser) => dispatch({ type: 'storeAuthenticatedUser', authenticatedUser: authenticatedUser }),
        storeAllGradesWithUnits: (all_grades_with_units) => dispatch({ type: 'storeAllGradesWithUnits', all_grades_with_units: all_grades_with_units }),
        setMainPageCode: (mainPageCode) => dispatch({ type: 'setMainPageCode', mainPageCode: mainPageCode })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent);
